import get from 'lodash.get';

const getButtonPresetVersion = (state) =>
  get(state, 'ws.template.meta.customization.buttonPresetVersion', null);

export default getButtonPresetVersion;
